import { useNavigate } from "react-router-dom";
import { Layout, Button, SectionLabel, SectionHeading, PageHero } from "../components.jsx";
import { navy, blue, INDUSTRIES } from "../data";

export default function Industries() {
  const navigate = useNavigate();

  return (
    <Layout>
      <PageHero
        label="Industries We Serve"
        title="Built for Operations-Heavy Businesses"
        subtitle="We focus on service businesses and operations-heavy industries — so we understand your workflows, your challenges, and what AI can realistically deliver."
      />

      {/* ── ALL INDUSTRIES ───────────────────────────────────────────────────── */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <SectionLabel>9 Industries</SectionLabel>
            <SectionHeading>Where We Focus</SectionHeading>
            <p className="text-gray-500 mt-4 max-w-xl mx-auto text-base">
              Deep industry knowledge means faster implementation, better results, and solutions that actually fit how your business operates.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {INDUSTRIES.map(ind => (
              <div key={ind.name} className="bg-white rounded-lg overflow-hidden border border-gray-100 hover:shadow-lg transition-shadow duration-200">
                <div className="p-5 border-b border-gray-100" style={{ background: navy }}>
                  <div className="text-2xl mb-2">{ind.icon}</div>
                  <h3 className="text-white font-bold text-base">{ind.name}</h3>
                  <p className="text-blue-300 text-xs mt-1 font-medium">{ind.value}</p>
                </div>
                <div className="p-5">
                  <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-2">Common Pain Points</p>
                  {ind.pains.map(p => <p key={p} className="text-gray-600 text-sm mb-1">• {p}</p>)}
                  <p className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-2 mt-4">What We Automate</p>
                  {ind.automation.map(a => <p key={a} className="text-blue-600 text-sm mb-1 font-medium">✓ {a}</p>)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY SERVICE BUSINESSES ──────────────────────────────────────────── */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <SectionLabel>Our Focus</SectionLabel>
          <SectionHeading>Why We Specialise in Service Businesses</SectionHeading>
          <p className="text-gray-500 mt-5 mb-8 leading-relaxed text-base max-w-2xl mx-auto">
            Service businesses and operations-heavy industries share a common set of challenges — high customer interaction volumes, repetitive internal workflows, and teams stretched thin by admin overhead. These are exactly the areas where AI creates the most immediate, measurable value.
          </p>
          <p className="text-gray-500 mb-10 leading-relaxed text-base max-w-2xl mx-auto">
            By focusing on a defined set of industries, we can go deep rather than wide. That means we understand your terminology, your workflows, your customer expectations — and we build AI systems that fit how you actually operate, not how we assume you do.
          </p>
          <Button onClick={() => navigate("/contact")}>Discuss Your Industry</Button>
        </div>
      </section>

      {/* ── CTA ─────────────────────────────────────────────────────────────── */}
      <section className="py-24" style={{ background: `linear-gradient(135deg, ${navy} 0%, #1a3260 100%)` }}>
        <div className="max-w-3xl mx-auto px-6 text-center">
          <SectionLabel>Get Started</SectionLabel>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Ready to See What AI Can Do in Your Industry?</h2>
          <p className="text-gray-300 text-base mb-10 max-w-xl mx-auto leading-relaxed">Book a free strategy call and we'll walk you through specific automation opportunities for your business — with no obligation.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button onClick={() => navigate("/contact")}>Book a Free Strategy Call</Button>
            <Button variant="secondary" onClick={() => navigate("/ai-assessment")}>Start With an Assessment</Button>
          </div>
        </div>
      </section>

    </Layout>
  );
}